module.exports = __webpack_public_path__ + "img/snippet-mew-wallet.a52b3d53.png";